import { render, staticRenderFns } from "./NotificationLog.vue?vue&type=template&id=c0dc0e9c&"
import script from "./NotificationLog.vue?vue&type=script&lang=js&"
export * from "./NotificationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports